import { render, staticRenderFns } from "./OrderProfile.vue?vue&type=template&id=63c4c7e8"
import script from "./OrderProfile.vue?vue&type=script&lang=js"
export * from "./OrderProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports